// UploadActivityPage.js

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BackButton from "../components/BackButton";
import ActivityUpload from "./ActivityUpload";

export default function UploadActivityPage(props) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="app-shell bg-blue-50">
      <header
        className="sticky top-0 left-0 right-0 z-30 bg-blue-50"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <div className="mt-2 mx-auto px-4 flex items-center">
          <BackButton className="text-blue-600" />
          <h1 className="flex-1 text-left text-[20px] text-blue-600 dm-font font-black tracking-[-0.06em] leading-[0.9]">
            Upload Activity
          </h1>
        </div>
      </header>

      <main className="app-content no-scrollbar w-full mb-2 pt-1.5">
        <ActivityUpload
          {...props}
          onClose={() => {
            const redirectId =
              location?.state?.redirectTo?.type === "circle"
                ? location.state.redirectTo.id
                : null;

            if (redirectId) {
              navigate(`/circles/${redirectId}?t=${Date.now()}`, {
                replace: true,
                state: { refresh: true },
              });
            } else {
              navigate("/home", { replace: true });
            }
          }}
        />
      </main>
    </div>
  );
}